import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, createSlots as _createSlots, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "m-auto px-8 md:px-20 pb-8" }
const _hoisted_2 = { class: "py-10 flex justify-between" }
const _hoisted_3 = { class: "max-w-screen-2xl m-auto" }
const _hoisted_4 = { class: "flex justify-between" }
const _hoisted_5 = { class: "text-2xl font-bold" }
const _hoisted_6 = { class: "rotate-x-180 overflow-x-scroll" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!
  const _component_ConfermaModal = _resolveComponent("ConfermaModal")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_NextTable = _resolveComponent("NextTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Breadcrumbs, { paths: _ctx.getBreadcrumbsPath }, null, 8, ["paths"])
    ]),
    _createVNode(_component_ConfermaModal, {
      onConfirm: _ctx.onConfirm,
      onReject: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modal_visible = false)),
      backdrop: true,
      visible: _ctx.modal_visible
    }, {
      default: _withCtx(() => _cache[2] || (_cache[2] = [
        _createTextVNode(" Confermi di voler riprendere questa versione? ")
      ])),
      _: 1
    }, 8, ["onConfirm", "visible"]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h1", _hoisted_5, " Sottoprogetto: " + _toDisplayString(_ctx.sottoprogetto?.titolo), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_NextTable, {
          class: "rotate-x-180 w-full border-separate border-spacing-3 py-4 table-fixed",
          cols: _ctx.fornitoriCols,
          "onUpdate:cols": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.fornitoriCols) = $event)),
          rows: _ctx.recordPerFornitore
        }, _createSlots({ _: 2 }, [
          _renderList(_ctx.recordPerFornitore, (c, j) => {
            return {
              name: `td_${j}_0`,
              fn: _withCtx(() => [
                _createTextVNode(_toDisplayString(c?.fornitore?.denominazione), 1)
              ])
            }
          }),
          _renderList(_ctx.recordPerFornitore, (c, j) => {
            return {
              name: `td_${j}_1`,
              fn: _withCtx((context) => [
                _createTextVNode(_toDisplayString(_ctx.$filters.toEuroCurrency(context.context.row.totale_utili)), 1)
              ])
            }
          }),
          _renderList(_ctx.recordPerFornitore, (c, j) => {
            return {
              name: `td_${j}_2`,
              fn: _withCtx((context) => [
                _createTextVNode(_toDisplayString(_ctx.$filters.toEuroCurrency(0)), 1)
              ])
            }
          }),
          _renderList(_ctx.recordPerFornitore, (c, j) => {
            return {
              name: `td_${j}_3`,
              fn: _withCtx((context) => [
                _createTextVNode(_toDisplayString(_ctx.$filters.toEuroCurrency(context.context.row.totale_ricavi)), 1)
              ])
            }
          }),
          _renderList(_ctx.recordPerFornitore, (c, j) => {
            return {
              name: `td_${j}_4`,
              fn: _withCtx((context) => [
                (_ctx.id && context.context.row?.fornitore?.id)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: {name:'SottoProgettoDettaglioFornitore', params:{id:_ctx.id, idf:context.context.row?.fornitore?.id}},
                      class: "text-center inset-0 absolute flex items-center justify-center"
                    }, {
                      default: _withCtx(() => _cache[3] || (_cache[3] = [
                        _createElementVNode("i", { class: "icon-chevron_destra" }, null, -1)
                      ])),
                      _: 2
                    }, 1032, ["to"]))
                  : _createCommentVNode("", true)
              ])
            }
          })
        ]), 1032, ["cols", "rows"])
      ])
    ])
  ]))
}